import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Skeleton } from '@mui/material';
import clsx from 'clsx';
import { Image } from 'lib/Image';

const PREFIX = 'ScenarioCard';

const classes = {
    journeySelectionWrapper: `${PREFIX}journeySelectionWrapper`,
    journeyImage: `${PREFIX}journeyImage`,
    journeyImageHidden: `${PREFIX}journeyImageHidden`
};

const StyledBox = styled(Box)(({ theme }) => ({
    paddingTop: `${(150 / 388) * 100}%`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    position: 'relative',
    [`& .${classes.journeyImage}`]: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    },

    [`& .${classes.journeyImageHidden}`]: {
        width: 0,
        height: 0
    }
}));

interface IProps {
    backgroundColor?: string;
    backgroundImg: string;
    defaultImage?: string;
    onClick?: () => void;
}

export const ScenarioCard: React.FC<React.PropsWithChildren<IProps>> = ({
    backgroundColor,
    backgroundImg,
    onClick,
    defaultImage
}) => {
    const [laoding, setLoading] = React.useState(true);

    const onLoad = React.useCallback(() => {
        setLoading(false);
    }, []);

    return (
        <StyledBox onClick={onClick} style={{ backgroundColor }}>
            <Skeleton
                className={classes.journeyImage}
                variant="rectangular"
                animation="wave"
                style={{ zIndex: 100, display: laoding ? 'block' : 'none' }}
            />
            <Image
                src={backgroundImg}
                onError={onLoad}
                onLoad={onLoad}
                fallbackSrc={defaultImage}
                className={clsx(classes.journeyImage, { [classes.journeyImageHidden]: laoding })}
            />
        </StyledBox>
    );
};
